const variables = {
  settings: {
    theme: 'light' as Theme,
  },
};

export default variables;
